<template>
    <b-modal id="group-words-modal" title="Keyword Group" size="md" modal-class="group-words-modal">
        <template #modal-title>
            Keyword Group: "{{rule.value}}"
        </template>

        <pulse-loader :loading="!loaded" :color="constants.spinnerColor"></pulse-loader>
        
        <ul class="manage-list manage-list--secondary">
            <li v-for="(word, index) in groupWords" :key="index">"{{word}}" <a @click="groupWords.splice(index, 1)" class="link-remove">Remove</a></li>
        </ul>
        <div class="buttons-list">
            <a class="btn btn-transparent" @click="groupWords.push(word)" v-for="(word, index) in relatedWords" :key="index" v-show="groupWords.indexOf(word) < 0">+ {{word}}</a>
            
            <div v-if="editMode" class="form-control form-control--sm">
                <input v-model="newWord" @keyup.enter="addWord" autofocus>
                <button @click="addWord">+Add</button>
            </div>
            <a class="btn btn-full" v-else @click="editMode = true">+ Add Keyword</a>
        </div>

        <template #modal-footer>
            <p v-if="groupWords.length">
                Must match at least
                <select v-model="matchCount" class="selectbox-regular">
                    <option v-for="i in matchArray" :value="i" :key="i">
                        {{i}}
                    </option>
                </select>
                keywords
            </p>

            <b-button variant="primary" size="lg" @click="saveGroupWords">Save</b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from "@/axios";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
    props: {
        rule: Object,
        allRelatedWords: Object
    },

    components: {
        PulseLoader
    },

    data() {
        return {
            groupWords: [],
            matchCount: 0,

            relatedWords: [],
            loaded: false,
            newWord: "",
            editMode: false
        }
    },

    watch: {
        groupWords() {
            if (this.matchCount > this.groupWords.length + 1) {
                this.matchCount = this.groupWords.length + 1
            }
        }
    },

    computed: {
        matchArray() {
            let list = []
            for (let i = 1; i <= this.groupWords.length + 1; ++i) {
                list.push(i)
            }

            return list
        }
    },

    methods: {
        init() {
            this.relatedWords = []
            this.groupWords = []

            for (let i in this.rule.groupWords) {
                this.groupWords.push(this.rule.groupWords[i])
                this.relatedWords.push(this.rule.groupWords[i])
            }

            this.matchCount = this.rule.matchCount
            this.getRelatedWords()
        },

        open() {
            this.init()
            this.$bvModal.show('group-words-modal')
        },

        saveGroupWords() {
            this.$emit('save-group-words', this.groupWords, this.matchCount);
            this.$bvModal.hide('group-words-modal')
        },

        getRelatedWords() {
            if (typeof this.allRelatedWords[this.rule.value] !== "undefined") {
                this.relatedWords = this.allRelatedWords[this.rule.value]
                this.loaded = true
            }
            else {
                this.loaded = false

                axios.post("/search/get-related-words", {term: this.rule.value}).then(response => {
                    for (let i in response.data) {
                        let word = response.data[i]

                        if (this.relatedWords.indexOf(word) < 0) {
                            this.relatedWords.push(word)
                        }
                    }

                    this.loaded = true
                })
            }
        },

        addWord() {
            if (this.newWord.length) {
                this.relatedWords.push(this.newWord)
                this.groupWords.push(this.newWord)
            }
            this.editMode = false
            this.newWord = ""
        }
    }
}
</script>

<style scoped>

</style>
